import { NgModule } from '@angular/core';
import { SafePipe } from './pipes/safe.pipe';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfraComponentsSharedModule } from './shared/infra-components-shared.module';
import { OutsideClickDirective } from './directives/outsideClick.directive';
import { GhostDirective } from './directives/ghost.directive';
import { UTooltipDirective } from './directives/u-tooltip.directive';
import { ShortUrlPipe } from './pipes/shortUrl.pipe';

const pipes = [ShortUrlPipe];

const providers = [ShortUrlPipe];

const directives = [OutsideClickDirective, GhostDirective];

const primeNgModules = [TableModule, OverlayPanelModule, DragDropModule];

const primengDirectives = [];

@NgModule({
  declarations: [...pipes, ...directives],
  providers: [...providers],
  imports: [SafePipe, UTooltipDirective],
  exports: [...pipes, SafePipe, ...primeNgModules, ...primengDirectives, InfraComponentsSharedModule, ...directives, UTooltipDirective],
})
export class UiInfraModule {}
